// logAttribution.js — print where each multi-record chunk's text went, and how
// that was decided, to the console. Diagnostic only: lets you watch attribution
// live without opening every visit. Session replay captures it too.

// conversationId -> patient label, registered by a page that knows the names
// (the Multi Recorder page). Without it the log shows visit ids.
let visitNames = {};
export const setAttributionNames = (names) => {
  visitNames = names || {};
};

const label = (id) => visitNames[id] || visitNames[Number(id)] || `visit ${id}`;

/**
 * @param {string} algorithm 'segmenter' | 'classic split'
 * @param {object} data the upload response
 * @param {number[]} targets the visits the chunk was uploaded under
 */
export function logAttribution(algorithm, data, targets) {
  try {
    const at = new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    const method = data?.attributionMethod || 'unknown method (older backend)';
    const lines = [];
    if (Array.isArray(data?.utterances)) {
      data.utterances.forEach((u) => lines.push([label(u.conversationId), u.text]));
    } else if (data?.transcripts && typeof data.transcripts === 'object') {
      Object.entries(data.transcripts).forEach(([id, text]) =>
        lines.push([label(id), text]),
      );
    }
    (data?.unplaced || []).forEach((u) => lines.push(['UNPLACED (ask clinician)', u.text]));

    console.groupCollapsed(
      `[MR attribution] ${at} · ${algorithm} · ${method} · ${lines.length} line(s) across [${(targets || []).map(label).join(', ')}]`,
    );
    lines.forEach(([who, text]) => console.log(`→ ${who}: ${text}`));
    if (!lines.length) console.log('(nothing attributed — silence or empty transcript)');
    console.groupEnd();
  } catch (e) {
    // Logging must never affect an upload.
  }
}
